import React, { useEffect, useState } from "react";
import api from "../utils/intercepter/axiosConfig.js";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const MesVentes = () => {
  const navigate = useNavigate();

  const [ventes, setVentes] = useState([]);
  const [idUser, setIdUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        setIdUser(decoded.data.id);
        console.log("ID utilisateur :", decoded.data.id);
      } catch (error) {
        setError("Token invalide.");
        setLoading(false);
      }
    } else {
      setError("Token manquant.");
      setLoading(false);
    }
  }, []);

  const fetchVentes = async () => {
    setLoading(true);
    try {
      const response = await api.post("/auth/getAllVentesByUserId", {
        id_user: idUser,
      });

      if (response.data.status) {
        setVentes(response.data.response);
      } else {
        setError(response.data.message || "Aucune vente trouvée.");
      }
    } catch (error) {
      setError("Erreur de chargement des ventes.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!idUser) return;
    fetchVentes();
  }, [idUser]);

  return (
    <div className="container text-center mt-5">
      <div className="row">
        {loading ? (
          <div className="container-fluid">
            {error ? (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            ) : (
              <div>Chargement...</div>
            )}
          </div>
        ) : ventes.length > 0 ? (
          <>
            {ventes.map((vente, index) => (
              <div key={index} className="col-12 col-md-4 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th className="text-start">N° Demande</th>
                          <td className="text-end">{vente.num_demande}</td>
                        </tr>
                        <tr>
                          <th className="text-start">NNI Vendeur</th>
                          <td className="text-end">{vente.nni_vendeur}</td>
                        </tr>
                        <tr>
                          <th className="text-start">Nom Vendeur</th>
                          <td className="text-end">{vente.nom_vendeur}</td>
                        </tr>
                        <tr>
                          <th className="text-start">NNI Acheteur</th>
                          <td className="text-end">{vente.nni_acheteur}</td>
                        </tr>
                        <tr>
                          <th className="text-start">Nom Acheteur</th>
                          <td className="text-end">{vente.nom_acheteur}</td>
                        </tr>
                        <tr>
                          <th className="text-start">TF</th>
                          <td className="text-end">
                            <span className="badge bg-warning text-white">
                              {vente.tf}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th className="text-start">Montant</th>
                          <td className="text-end">
                            <span className="fw-bold text-success">
                              {vente.montant.toLocaleString("fr-FR", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}{" "}
                              MRU
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th className="text-start">Date</th>
                          <td className="text-end">{vente.date}</td>
                        </tr>
                        <tr>
                          <th className="text-start">État</th>
                          <td className="text-end">
                            {vente.Etat === 1 ? (
                              <span className="badge bg-success">En cours de vente</span>
                            ) : (
                              <span className="badge bg-danger">Non Validée</span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="row">
                      <div className="col-12">
                        <button
                          className="btn btn-success btn-sm w-100"
                          onClick={() => {
                            navigate(`/vente/details/${vente.num_vente}`);
                          }}
                        >
                          Voir
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="container">
            <div className="alert alert-danger w-100" role="alert">
            Aucune vente trouvée.
          </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MesVentes;